define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/access/crews",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/html",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ColorPalette/ColorForm",
	"Apparel/ProductType",
], function(declare, lang, csi, _, crews, def, Field, Relationship, html, xml, Query, ColorForm, ProductType) {

	return declare(ColorForm, {
		bShowThemeColor: false,

		/**
		 * @override
		 * Add ColorwayThemeColor or ColorPalette Fields based on the config point
		 */
		_resolveView: function() {
			const ac = this.defView.getSource();
			if (!ac) {
				return this.inherited(arguments);
			}
			// use action controller cache so that nodes won't have to be queried every time from form cache
			const cache = ac.getCache();
			const style = ac.getParent();

			if (ProductType.get(style, "ColorPaletteRule") == "ColorPaletteRuleTypes:Enforced") {
				return this.inherited(arguments);
			}
			// If copying/editing colorway where ColorSpecification is limited to Style Theme's colors, then need to add
			// additional field to select one, which will drive the Colorway's ColorSpecification field
			var f = this.defView.getField("ColorSpecification");
			if (f) {
				const theme = cache.getNode(style.Theme);
				if (theme) {
					if (theme.LimitColorColorways) {
						this._bResetColorStore = true;
						f.m_right = xml.RIGHT_NONE;
					}

					if (theme.ColorColorways.length) {
						this.defView.addField(lang.mixin(new Field(), {
							m_label: "ColorwayThemeColor",
							m_onChange: "_onChangeThemeColor",
							m_typeControl: def.FIELD_FILTERING_SELECT,
							m_relationship: lang.mixin(new Relationship(), {
								m_url: theme.$URL,
								m_id: "ColorColorways",
								m_query: new Query().Attr("Available", xml.OP_EQUALS, true)
							})
						}), "ColorSpecification");

						if (!theme.LimitColorColorways) {
							f.m_onChange = "_onChangeColor";
						}
					}
				}

				var allowCreateColorSpec = ProductType.get(style, "AllowCreateColorSpecOnColorway");

				// check if we have the allow create color spec flag true or not for creation of colorway
				if (allowCreateColorSpec && this._hasColorSpecAccess() && !this.isNewFrom()
					&& this.isNew() && this.getSourceView().getViewNode().$Type == "Style") {

					var colorSpecField = this.defView.getField("ColorSpecification");

					this.defView.removeField("ColorSpecification");

					// if yes, add the Create Specification checkbox and New ColorSpec form to the current form
					var createCheckboxField = lang.mixin(new Field(), {
						m_label: "CreateColorSpecification",
						m_onChange: "onChangeCreateColorSpecification",
						m_typeControl: def.FIELD_CHECKBOX,
						idParameter: "CreateColorSpecification"
					});
					this.defView.addField(createCheckboxField);
					this.defView.addField(colorSpecField);

					this.combineForm(false, "ColorSpecification", "ColorSpecification", {notApplicable: true});
				}
			}

			this.inherited(arguments);
		},

		_hasColorSpecAccess: function() {
			return crews.isInGlobalRoles(["Color Administrator", "Color Editor"]);
		},

		_getCustomSecondaryFormFields: function() {
			return [lang.mixin(new Field(), {
				m_id: xml.ATTR_NAME,
				m_typeControl: def.FIELD_TEXT
			})];
		},

		_buildField: function(/*Context*/ctx, /*Field*/field, /*DOMNode*/tr, /*DOMNode?*/tdControl) {
			var control = this.inherited(arguments);

			if (field.combinedFormType) {
				this.setFieldHidden(field, true);
			}

			return control;
		},

		_onChangeColor: function(/*View*/defView, /*Field*/field, /*Any*/value) {
			// summary: set ColorSpecification to Theme Color's Actual
			var urlThemeColor = this.defView.getFieldValue("ColorwayThemeColor");
			var ccc = this.cacheView.getNode(urlThemeColor);
			if (ccc && (value != ccc.Actual)) {
				this.setFieldValue("ColorwayThemeColor", csi.EMPTY_URL);
			}
		},

		_onChangeThemeColor: function(/*View*/defView, /*Field*/field, /*Any*/value) {
			// summary: set ColorSpecification to Theme Color's Actual
			if (value != csi.EMPTY_URL) {
				var fieldColor = this.defView.getField("ColorSpecification");
				var urlColor = this.cacheView.getNode(value).Actual;

				if (!this.isNewFrom()) {
					this.setFieldValue("ColorPalette", csi.EMPTY_URL);
				}

				if (this._bResetColorStore) {
					// if limiting colors, then reset with store of just selected color
					this.cacheView.getNode(urlColor);
					fieldColor.m_control.set("store", this.getFieldStore(fieldColor, urlColor));
					this.setFieldDisabled("ColorSpecification", !this.isNewFrom());
				}

				this.setFieldValue(fieldColor, urlColor);
			}
		},

		onChangeCreateColorSpecification: function(formView, field, value) {
			_.each(formView.m_fields, function(otherField) {
				if (otherField.combinedFormType) {
					otherField.notApplicable = !value;
					this.setFieldHidden(otherField, !value);
					var defaultValue = xml.attributeTypeGetDefaultValue(otherField.getType());
					this.setFieldValue(otherField, defaultValue); // set all fields tied to the color spec to blank

					// populate store
					if (value) {
						otherField.m_control.set("store", this.getFieldStore(otherField));
					}
				}
			}, this);

			const colorSpecField = this.getField("ColorSpecification");
			if (colorSpecField) {
				colorSpecField.notApplicable = value;
				this.setFieldHidden(colorSpecField, value);
				this.setFieldValue(colorSpecField, csi.EMPTY_URL);
			}

			var themeColor = this.getField("ColorwayThemeColor");
			if (themeColor) {
				if (value) {
					this.setFieldValue(themeColor, csi.EMPTY_URL);
				}
				html.setDisabled(themeColor.m_control, value);
			}
		},

		/**
		 * @override
		 * Check for enums and return the value from the store if it is an enum
		 */
		_getFormReportFieldValue(formNode, field) {
			let value = this.inherited(arguments);
			const isEnum = (field.getType() === xml.ATTR_ENUM);
			if (isEnum) {
				value ||= xml.enumCreate(field.m_format);
			}
			return value;
		},
	});
});
